import { useContext } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import FooterContext from "../../../context/FooterContext/FooterContext";
import { footerStyle1Reset } from "../../../constant";
import FooterTheme3 from "../ScreenShorts/Footer/FooterTheme2.png";
import ThemeImageShow from "../../../common/ThemeImageShow";
import FooterThreeThemeOne from "./FooterThreeThemeOne";

const FooterStyleThreePopup = (props) => {
  const { isEdit, setFormData, imgShow, setImgShow } =
    useContext(FooterContext);
  const { submitForm } = props;

  /**
   * input value change
   * @param {event} e
   */

  const resetHandler = () => {
    let footerStyle;
    footerStyle = footerStyle1Reset;
    setFormData({
      footer3Style: footerStyle,
    });
  };

  const handleClose = () => {
    setImgShow(false);
  };
  const FooterTheme3img = FooterTheme3;

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button
                    onClick={() =>
                      submitForm({
                        formValidationCondition: "footerThreeStyleForm",
                        isRestore: true,
                      })
                    }
                  >
                    Restore
                  </Button>
                  <Button
                    onClick={() =>
                      submitForm({
                        formValidationCondition: "footerThreeStyleForm",
                        isClose: false,
                      })
                    }
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={FooterTheme3img}
                  handleClose={handleClose}
                />
              )}{" "}
              <FooterThreeThemeOne />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FooterStyleThreePopup;
